module.exports = __webpack_public_path__ + "static/lifebyframe-e10429449855a3fa746cdb1544791c24.png";